import * as jsjoda from '@js-joda/core';
import { delay, forever } from './promise';
const __request = async (url, m, c) => {
    try {
        const response = await fetch(url, c || {});
        const status = response.status;
        const error = () => {
            console.error(`_request.error - ${url}: ${response.status}`);
            return forever();
        };
        switch (status) {
            case 200:
                return m[status](response);
            case 400:
            case 404:
            case 422:
            case 500:
                return ((f) => f ? f(response) : error())(m && m[status]);
            default:
                console.error(`_request.error - ${url}: ${response.status}`);
                return forever();
        }
    }
    catch (e) {
        if (e.name === 'AbortError') {
            console.info(`_request.aborted - ${url}`);
        }
        else {
            console.error(e);
        }
        return forever();
    }
};
export const getJson = (url) => (c, m) => __request(url, m({ 200: (r) => r.json() }), c({}));
function stringifier(k, v) {
    if (this[k] instanceof jsjoda.LocalDate) {
        return this[k].format(jsjoda.DateTimeFormatter.ofPattern('yyyy-MM-dd'));
    }
    if (this[k] instanceof jsjoda.LocalTime) {
        return this[k].format(jsjoda.DateTimeFormatter.ofPattern('HH:mm:ss'));
    }
    if (this[k] instanceof jsjoda.LocalDateTime) {
        return this[k].format(jsjoda.DateTimeFormatter.ofPattern('yyyy-MM-dd HH:mm:ss'));
    }
    return v;
}
export const postJson = (url, body) => (c, m) => __request(url, m({ 200: (r) => r.json() }), c({ 'method': 'POST', 'body': JSON.stringify(body, stringifier) }));
export const deleteJson = (url, body) => (c, m) => __request(url, m({ 200: (r) => r.json() }), c({ 'method': 'DELETE', 'body': JSON.stringify(body, stringifier) }));
export const withDone = (f) => () => {
    return f((x) => x, (x) => x);
};
export const withDelay = (n, f) => (c, m) => f(c, (m2) => m({
    200: async (x) => { await delay(n); return m2[200](x); },
}));
export const withAbort = (f) => {
    const controller = new AbortController();
    return [(c, m) => f((x) => c({ ...x, 'signal': controller.signal }), m), () => { controller.abort(); }];
};
export const withValidate = (f) => (c, m) => f(c, (m2) => m({
    200: async (x) => [true, await m2[200](x)],
    422: async (x) => [false, await x.json()],
}));
export const withOptional = (f) => {
    return (c, m) => f(c, (m2) => m({
        ...m2,
        404: async (_) => null,
    }));
};
